import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";
import LogoutFunction from "../../../services/LogoutFunction";

export const updateFeedbackFunc = createAsyncThunk(
  "feedback/update",
  async ({data , id}) => {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
    const request = await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/users/feedbacks/${id}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        //   "Content-Type": "application/x-www-form-urlencoded",
        },
        body: data,
      }
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(data)
        return result;
      })
      .catch((error) => {
        console.log(data)
        formatError(error);
        return error;
      });

    return request;
  }
);

function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}
const updateFeedbackSlicer = createSlice({
  name: "feedback/update",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(updateFeedbackFunc.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(updateFeedbackFunc.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "jwt expired") {
        state.error = action.payload.message;
        formatError(state.error);
        LogoutFunction();
      } else if (action.payload.message === "Done") {
        state.data = action.payload.data;
      } else {
        state.error = action.payload.message;
        formatError(state.error);
      }
    });
    builder.addCase(updateFeedbackFunc.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
      formatError(state.error);
    });
  },
});

export default updateFeedbackSlicer.reducer;
